import React from "react";
import {css} from "@panda/css";

import {Text} from "@pg-design/text-module";
import {Country} from "@pg-rp/common-types";

import {ShowMoreWrapperWithLineClamp} from "../../../atoms/ShowMoreWrapperWithLineClamp";
import {IVariablesStore} from "../../../variables/reducers/variables_reducer";
import {IVendorDetail} from "../../types/IVendorDetail";
import {VendorDetailGeneratedDescription} from "./VendorDetailGeneratedDescription";
import {VendorDetailRecommendation} from "./VendorDetailRecommendation";

interface IProps {
    vendor: IVendorDetail;
    variables: IVariablesStore;
    flatsOffers: {
        name: string;
        region: {
            country: Country;
        };
    }[];
    housesOffers: {
        name: string;
        region: {
            country: Country;
        };
    }[];
    commercialsOffers: {
        name: string;
        region: {
            country: Country;
        };
    }[];
}

export const VendorDetailDescription = (props: IProps) => {
    const {vendor, variables, flatsOffers, housesOffers, commercialsOffers} = props;
    const shouldGenerateAdditionalDescription = !vendor.description || vendor.description.length < 300;

    return (
        <>
            <Text as="h2" variant="headline_3" className={css({mb: 5, md: {mb: 7}})}>
                Informacje o nas
            </Text>

            {vendor.recommendation && <VendorDetailRecommendation vendor={vendor} variables={variables} />}

            <ShowMoreWrapperWithLineClamp maxLinesToShow={8}>
                {vendor.description && (
                    <>
                        {vendor.description.split("\n").map((item, key) => (
                            <Text key={key} as="p" variant="body_copy_2" mb={0.5}>
                                {item.trim()}
                            </Text>
                        ))}
                    </>
                )}

                {shouldGenerateAdditionalDescription && (
                    <VendorDetailGeneratedDescription
                        vendor={vendor}
                        variables={variables}
                        flatsOffers={flatsOffers}
                        housesOffers={housesOffers}
                        commercialsOffers={commercialsOffers}
                    />
                )}
            </ShowMoreWrapperWithLineClamp>
        </>
    );
};
import React from "react";
import {css} from "@panda/css";

import {Text} from "@pg-design/text-module";
import {Country} from "@pg-rp/common-types";

import {ShowMoreWrapperWithLineClamp} from "../../../atoms/ShowMoreWrapperWithLineClamp";
import {IVariablesStore} from "../../../variables/reducers/variables_reducer";
import {IVendorDetail} from "../../types/IVendorDetail";
import {VendorDetailGeneratedDescription} from "./VendorDetailGeneratedDescription";
import {VendorDetailRecommendation} from "./VendorDetailRecommendation";

interface IProps {
    vendor: IVendorDetail;
    variables: IVariablesStore;
    flatsOffers: {
        name: string;
        region: {
            country: Country;
        };
    }[];
    housesOffers: {
        name: string;
        region: {
            country: Country;
        };
    }[];
    commercialsOffers: {
        name: string;
        region: {
            country: Country;
        };
    }[];
}

export const VendorDetailDescription = (props: IProps) => {
    const {vendor, variables, flatsOffers, housesOffers, commercialsOffers} = props;
    const shouldGenerateAdditionalDescription = !vendor.description || vendor.description.length < 300;

    return (
        <>
            <Text as="h2" variant="headline_3" className={css({mb: 5, md: {mb: 7}})}>
                Informacje o nas
            </Text>

            {vendor.recommendation && <VendorDetailRecommendation vendor={vendor} variables={variables} />}

            <ShowMoreWrapperWithLineClamp maxLinesToShow={8}>
                {vendor.description && (
                    <>
                        {vendor.description.split("\n").map((item, key) => (
                            <Text key={key} as="p" variant="body_copy_2" mb={0.5}>
                                {item.trim()}
                            </Text>
                        ))}
                    </>
                )}

                {shouldGenerateAdditionalDescription && (
                    <VendorDetailGeneratedDescription
                        vendor={vendor}
                        variables={variables}
                        flatsOffers={flatsOffers}
                        housesOffers={housesOffers}
                        commercialsOffers={commercialsOffers}
                    />
                )}
            </ShowMoreWrapperWithLineClamp>
        </>
    );
};
